export default __webpack_public_path__ + "static/media/Labor.a3cc12f7.svg";